<style lang="scss" scoped>
.page-wrap {
  padding: 8px 0 80px;
  font-family: 'Segoe UI', sans-serif;
}

.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #eef2fb;
  border-bottom: 1px solid #dde4f5;

  .panel-title {
    font-size: 13px;
    font-weight: 700;
    color: #389ad4;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn-create {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 34px;
    padding: 0 16px;
    background: #F58020;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
      color: #fff;
    }
  }
}

.toolbar {
  padding: 12px 20px;
  border-bottom: 1px solid #f0f3fa;
}

/* ── Table ── */
.notif-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;

  thead tr th {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #7a8499;
    padding: 10px 16px;
    border-bottom: 2px solid #eef0f8;
    background: #fff;
    white-space: nowrap;
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f8fbff;
    }

    &.row-active {
      background: #eff8ff;
    }

    td {
      padding: 11px 16px;
      color: #2d3748;
      vertical-align: middle;
    }
  }
}

.col-title {
  font-weight: 500;
  color: #0d1b3e;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-date {
  font-size: 12px;
  color: #4a5568;
  white-space: nowrap;
}

.col-window {
  font-size: 12px;
  color: #4a5568;
  white-space: nowrap;

  .arrow {
    color: #a0aab8;
    margin: 0 4px;
  }
}

/* ── Badges ── */
.badge-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;

  &.urgent {
    background: #fed7d7;
    color: #c53030;
  }

  &.normal {
    background: #c6f6d5;
    color: #276749;
  }

  &.yes {
    background: #bee3f8;
    color: #2b6cb0;
  }

  &.no {
    background: #e2e8f0;
    color: #718096;
  }

  &.active {
    background: #c6f6d5;
    color: #276749;
  }

  &.inactive {
    background: #e2e8f0;
    color: #718096;
  }
}

/* ── Action dropdown ── */
.action-wrap {
  position: relative;
  display: inline-block;

  .action-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: #f5f7fa;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: #4a5568;
    letter-spacing: 1px;
    transition: background 0.15s;

    &:hover {
      background: #eef2fb;
      color: #185FA5;
      border-color: #c5d4f0;
    }
  }

  .action-menu {
    display: none;
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    min-width: 150px;
    box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
    z-index: 100;
    overflow: hidden;

    &.dropup {
      top: auto;
      bottom: calc(100% + 4px);
    }

    .menu-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 14px;
      font-size: 13px;
      color: #2d3748;
      cursor: pointer;
      transition: background 0.15s;

      i {
        width: 14px;
        color: #7a8499;
        font-size: 12px;
      }

      &:hover {
        background: #f8fbff;
        color: #185FA5;

        i {
          color: #389ad4;
        }
      }

      &.danger {
        color: #c62828;
        i { color: #c62828; }
        &:hover { background: #fff5f5; }
      }

      &.blue {
        color: #1a6fa0;
        i { color: #389ad4; }
        &:hover { background: #eef7fb; color: #1a6fa0; }
      }

      &.purple {
        color: #553c9a;
        i { color: #6b46c1; }
        &:hover { background: #f5f0ff; color: #553c9a; }
      }

      &.orange {
        color: #c05621;
        i { color: #dd6b20; }
        &:hover { background: #fff7ed; color: #c05621; }
      }
    }
  }

  &.open .action-menu {
    display: block;
  }
}

/* ── Empty / loading states ── */
.state-box {
  text-align: center;
  padding: 56px 24px;
  color: #a0aab8;
  font-size: 13px;

  i {
    font-size: 30px;
    display: block;
    margin-bottom: 10px;
    opacity: 0.45;
  }
}

/* ── Pagination ── */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #f0f3fa;
  flex-wrap: wrap;
  gap: 10px;

  .pg-info {
    font-size: 12px;
    color: #7a8499;
    white-space: nowrap;
  }

  .pg-controls {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .pg-btn {
    min-width: 32px;
    height: 32px;
    padding: 0 8px;
    border: 1.5px solid #dde2ec;
    background: #fff;
    color: #4a5568;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;

    &:hover:not(:disabled) {
      border-color: #389ad4;
      color: #389ad4;
    }

    &:disabled {
      opacity: 0.35;
      cursor: default;
    }

    &.active {
      background: #389ad4;
      border-color: #389ad4;
      color: #fff;
    }
  }

  .pg-size select {
    height: 32px;
    border: 1.5px solid #dde2ec;
    border-radius: 6px;
    padding: 0 8px;
    font-size: 12px;
    color: #4a5568;
    background: #fff;
    cursor: pointer;
    outline: none;

    &:focus {
      border-color: #389ad4;
    }
  }
}

/* ── Preview shared pieces ── */
.preview-urgency {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 600;
  margin-bottom: 14px;

  &.urgent { background: #fed7d7; color: #c53030; }
  &.normal  { background: #c6f6d5; color: #276749; }
}

.preview-body {
  background: #f8fafd;
  border: 1px solid #e8edf5;
  border-radius: 10px;
  padding: 14px 18px;
  font-size: 13.5px;
  line-height: 1.7;
  color: #2d3748;
  max-height: 260px;
  overflow-y: auto;
}

.preview-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 14px;
  font-size: 12px;
  color: #7a8499;

  span strong { color: #4a5568; }
}

/* ── Overlay wrapper (shared by preview + delete) ── */
.notif-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 62, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(3px);
  padding: 20px;
  font-family: 'Segoe UI', sans-serif;
}

/* ── Preview card ── */
.preview-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(13, 27, 62, 0.2);
  width: 100%;
  max-width: 560px;
  overflow: hidden;
}

.preview-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #eef0f8;
  gap: 12px;

  .ph-title-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 0;
  }

  .ph-icon {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    background: linear-gradient(135deg, #1E6FB8, #389ad4);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    flex-shrink: 0;
  }

  .ph-title {
    font-size: 14px;
    font-weight: 700;
    color: #0d1b3e;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ph-close {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    background: #f5f7fa;
    border: none;
    color: #7a8499;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.15s;

    &:hover { background: #eef2fb; color: #2d3748; }
  }
}

.preview-card-body { padding: 18px 22px; }

.preview-card-footer {
  padding: 12px 22px;
  border-top: 1px solid #f0f3fa;
  display: flex;
  justify-content: flex-end;

  button {
    height: 36px;
    padding: 0 20px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    border: 1.5px solid #dde2ec;
    background: #fff;
    color: #4a5568;
    transition: all 0.15s;

    &:hover { border-color: #a0aab8; color: #2d3748; }
  }
}

/* ── Delete confirm dialog ── */
.confirm-dialog {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 24px 64px rgba(13, 27, 62, 0.22);
  width: 100%;
  max-width: 380px;
  padding: 28px 24px 24px;
  text-align: center;
  font-family: 'Segoe UI', sans-serif;

  .cd-icon-wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 14px;

    .cd-icon {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
    }

    &.danger .cd-icon {
      background: linear-gradient(135deg, #c62828, #e53e3e);
      color: #fff;
      box-shadow: 0 6px 18px rgba(229, 62, 62, 0.3);
    }
  }

  .cd-title {
    font-size: 16px;
    font-weight: 700;
    color: #0d1b3e;
    margin-bottom: 6px;
  }

  .cd-sub {
    font-size: 13px;
    color: #7a8499;
    margin-bottom: 20px;
    line-height: 1.5;
  }

  .cd-item-card {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #f8fafd;
    border: 1px solid #e8edf5;
    border-radius: 10px;
    padding: 11px 14px;
    margin-bottom: 22px;
    text-align: left;

    .cdic-icon {
      width: 30px;
      height: 30px;
      border-radius: 7px;
      background: #fff0f0;
      color: #e53e3e;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      flex-shrink: 0;
    }

    .cdic-text {
      font-size: 13px;
      font-weight: 600;
      color: #0d1b3e;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
    }
  }
}

.confirm-footer {
  display: flex;
  gap: 10px;

  button {
    flex: 1;
    height: 40px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border: 1.5px solid transparent;
  }
}

.btn-cd-cancel {
  background: #fff;
  color: #4a5568;
  border-color: #dde2ec;

  &:hover { border-color: #a0aab8; color: #2d3748; }
}

.btn-cd-danger {
  background: #e53e3e;
  color: #fff;
  border-color: #e53e3e;

  &:hover { background: #c62828; border-color: #c62828; }
}
</style>

<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <span class="panel-title">
          <i class="fa fa-bell"></i>
          Notifications
          <span style="font-size:12px; color:#7a8499; font-weight:400;" v-if="notifications.length">
            ({{ notifications.length }})
          </span>
        </span>
        <router-link :to="{ name: 'admin.create.notification' }" class="btn-create">
          <i class="fa fa-plus"></i> Create Notification
        </router-link>
      </div>

      <!-- Date filter toolbar -->
      <div class="toolbar">
        <adv-search @search="advSearch" :is_date_range="true" :is_service="false" :is_status="false"
          :is_job_report="false" :is_location="false" :is_admin_sp_location="false" :is_admin_sp="false"
          :is_payment_status="false" :is_location_appointment="false" :titleworksheet="titleworksheet"
          :has_rating="false" :json_fields="{}" />
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="dataLoading">
        <i class="fa fa-spinner fa-spin"></i>
        Loading notifications…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="notifications.length === 0">
        <i class="fa fa-bell-slash"></i>
        No notifications found
      </div>

      <!-- Table -->
      <div v-else style="overflow-x: auto;">
        <table class="notif-table">
          <thead>
            <tr>
              <th style="width:40px;">#</th>
              <th>Title</th>
              <th>Created</th>
              <th>Visibility Window</th>
              <th style="text-align:center;">Urgency</th>
              <th style="text-align:center;">Email</th>
              <th style="text-align:center;">Active</th>
              <th style="width:60px; text-align:center;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(notification, index) in pagedList" :key="index" @click="openModal(notification)"
              :class="notification.id === notificationData.id ? 'row-active' : ''">
              <td style="color:#a0aab8; font-size:12px;">{{ (currentPage - 1) * perPage + index + 1 }}</td>
              <td class="col-title" :title="notification.title">{{ notification.title }}</td>
              <td class="col-date">{{ formatDate(notification.created_at) }}</td>
              <td class="col-window">
                {{ formatDate(notification.visible_from) }}
                <span class="arrow">→</span>
                {{ formatDate(notification.visible_until) }}
              </td>
              <td style="text-align:center;">
                <span :class="['badge-pill', notification.is_urgent ? 'urgent' : 'normal']">
                  <i :class="notification.is_urgent ? 'fa fa-exclamation-circle' : 'fa fa-check-circle'"></i>
                  {{ notification.is_urgent ? 'Urgent' : 'Normal' }}
                </span>
              </td>
              <td style="text-align:center;">
                <span :class="['badge-pill', notification.send_to_email ? 'yes' : 'no']">
                  {{ notification.send_to_email ? 'Yes' : 'No' }}
                </span>
              </td>
              <td style="text-align:center;">
                <span :class="['badge-pill', notification.is_active ? 'active' : 'inactive']">
                  {{ notification.is_active ? 'Active' : 'Inactive' }}
                </span>
              </td>
              <td style="text-align:center;" @click.stop>
                <div class="action-wrap" :class="{ open: openIndex === index }"
                  @click.stop="toggleDropdown(index, $event)" :ref="`dropdown-${index}`">
                  <div class="action-btn">•••</div>
                  <div class="action-menu" :class="{ dropup: dropupIndex === index }">
                    <div class="menu-item blue" @click.stop="openModal(notification)">
                      <i class="fa fa-eye"></i> View
                    </div>
                    <div class="menu-item purple" @click.stop="viewNotificationReport(notification)">
                      <i class="fa fa-chart-bar"></i> Viewer Report
                    </div>
                    <div class="menu-item orange" v-if="notification.is_editable" @click.stop="editNotification(notification)">
                      <i class="fa fa-pencil-alt"></i> Edit
                    </div>
                    <div class="menu-item danger" v-if="notification.is_deletable"
                      @click.stop="openDeleteModal(notification)">
                      <i class="fa fa-trash"></i> Delete
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-bar" v-if="notifications.length > perPage">
        <span class="pg-info">
          Showing {{ (currentPage - 1) * perPage + 1 }}–{{ Math.min(currentPage * perPage, notifications.length) }}
          of {{ notifications.length }}
        </span>
        <div class="pg-controls">
          <button class="pg-btn" :disabled="currentPage === 1" @click="currentPage = 1">
            <i class="fa fa-angle-double-left"></i>
          </button>
          <button class="pg-btn" :disabled="currentPage === 1" @click="currentPage--">
            <i class="fa fa-angle-left"></i>
          </button>
          <button v-for="p in visiblePages" :key="p" class="pg-btn" :class="{ active: p === currentPage }"
            @click="currentPage = p">{{ p }}</button>
          <button class="pg-btn" :disabled="currentPage === totalPages" @click="currentPage++">
            <i class="fa fa-angle-right"></i>
          </button>
          <button class="pg-btn" :disabled="currentPage === totalPages" @click="currentPage = totalPages">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>
        <div class="pg-size">
          <select v-model="perPage" @change="currentPage = 1">
            <option :value="10">10 / page</option>
            <option :value="25">25 / page</option>
            <option :value="50">50 / page</option>
          </select>
        </div>
      </div>

    </div>

    <!-- Preview overlay -->
    <div class="notif-overlay" v-if="activeModal === 'preview'" @click.self="closeModal">
      <div class="preview-card">
        <div class="preview-card-header">
          <div class="ph-title-wrap">
            <div class="ph-icon"><i class="fa fa-bell"></i></div>
            <div class="ph-title" :title="notificationData.title">{{ notificationData.title }}</div>
          </div>
          <button class="ph-close" @click="closeModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="preview-card-body">
          <span v-if="notificationData.title" :class="['preview-urgency', notificationData.is_urgent ? 'urgent' : 'normal']">
            <i :class="notificationData.is_urgent ? 'fa fa-exclamation-circle' : 'fa fa-check-circle'"></i>
            {{ notificationData.is_urgent ? 'Urgent' : 'Normal' }}
          </span>
          <div class="preview-body" v-if="notificationData.details" v-html="notificationData.details"></div>
          <div class="preview-meta" v-if="notificationData.title">
            <span><strong>Visible:</strong> {{ formatDate(notificationData.visible_from) }} → {{ formatDate(notificationData.visible_until) }}</span>
            <span><strong>Email:</strong> {{ notificationData.send_to_email ? 'Yes' : 'No' }}</span>
            <span><strong>Created:</strong> {{ formatDate(notificationData.created_at) }}</span>
          </div>
        </div>
        <div class="preview-card-footer">
          <button @click="closeModal">Close</button>
        </div>
      </div>
    </div>

    <!-- Delete confirm overlay -->
    <div class="notif-overlay" v-if="activeModal === 'delete'" @click.self="activeModal = null">
      <div class="confirm-dialog">
        <div class="cd-icon-wrap danger">
          <div class="cd-icon"><i class="fa fa-trash"></i></div>
        </div>
        <div class="cd-title">Delete Notification</div>
        <div class="cd-sub">This notification will be permanently removed.</div>
        <div class="cd-item-card" v-if="modalItem">
          <div class="cdic-icon"><i class="fa fa-bell"></i></div>
          <div class="cdic-text">{{ modalItem.title }}</div>
        </div>
        <div class="confirm-footer">
          <button class="btn-cd-cancel" @click="activeModal = null">Cancel</button>
          <button class="btn-cd-danger" @click="confirmDelete">
            <i class="fa fa-trash"></i> Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  FETCH_NOTIFICATIONS,
  DELETE_NOTIFICATION
} from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import vDataLoader from "@/components/frontend/spinner.vue";
import AdvSearch from "@/includes/search/AdvSearch";

export default {
  components: { vDataLoader, AdvSearch },
  computed: {
    ...mapGetters(["currentUser"]),
    totalPages() {
      return Math.ceil(this.notifications.length / this.perPage) || 1;
    },
    pagedList() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.notifications.slice(start, start + this.perPage);
    },
    visiblePages() {
      const total = this.totalPages;
      const cur = this.currentPage;
      const delta = 2;
      const pages = [];
      for (let i = Math.max(1, cur - delta); i <= Math.min(total, cur + delta); i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  data() {
    return {
      search: { date_from: "", date_to: "", search_text: "" },
      currentPage: 1,
      perPage: 10,
      openIndex: null,
      dropupIndex: null,
      titleworksheet: "",
      notifications: [],
      dataLoading: false,
      activeModal: null,
      modalItem: null,
      notificationData: {},
    };
  },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, [
      { id: 1, title: "Dashboard", route: "client.dashboard" },
      { id: 2, title: "Notifications", route: "" },
    ]);
    this.LoadAllNotifications();
    document.addEventListener("click", this.closeDropdown);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
  },
  methods: {
    advSearch(value) {
      this.dataLoading = true;
      const { search } = value;
      this.search = { ...search };
      this.titleworksheet = search.date_from + " - " + search.date_to;
      this.$store.dispatch(FETCH_NOTIFICATIONS, search)
        .then(res => { this.dataLoading = false; this.notifications = res.data; this.currentPage = 1; })
        .catch(() => { this.dataLoading = false; this.$toastr.e("Error fetching notifications"); });
    },
    LoadAllNotifications() {
      this.dataLoading = true;
      this.$store.dispatch(FETCH_NOTIFICATIONS)
        .then(res => { this.dataLoading = false; this.notifications = res.data; this.currentPage = 1; })
        .catch(() => { this.dataLoading = false; this.$toastr.e("Error fetching notifications"); });
    },
    formatDate(date) {
      if (!date) return "—";
      return new Date(date).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
    },
    openModal(notification) {
      this.notificationData = notification;
      this.activeModal = 'preview';
      this.openIndex = null;
    },
    closeModal() {
      this.activeModal = null;
      setTimeout(() => { this.notificationData = {}; }, 200);
    },
    openDeleteModal(notification) {
      this.modalItem = notification;
      this.activeModal = 'delete';
      this.openIndex = null;
    },
    confirmDelete() {
      this.$store.dispatch(DELETE_NOTIFICATION, this.modalItem.id)
        .then(() => {
          this.$toastr.s("Notification deleted");
          this.activeModal = null;
          this.modalItem = null;
          this.LoadAllNotifications();
        })
        .catch(() => { this.$toastr.e("Error deleting notification"); });
    },
    editNotification(notification) {
      this.$router.push({ name: "admin.edit.notification", params: { notification_id: notification.id } });
    },
    viewNotificationReport(notification) {
      this.$router.push({ name: "admin.view.notification.report", params: { notification_id: notification.id } });
    },
    toggleDropdown(index, event) {
      this.openIndex = this.openIndex === index ? null : index;
      if (this.openIndex === index) {
        this.$nextTick(() => {
          const el = event.currentTarget;
          const menu = el.querySelector(".action-menu");
          if (menu) {
            const rect = el.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            this.dropupIndex = spaceBelow < (menu.scrollHeight || 150) + 30 ? index : null;
          }
        });
      } else {
        this.dropupIndex = null;
      }
    },
    closeDropdown() {
      this.openIndex = null;
      this.dropupIndex = null;
    },
  },
};
</script>
